import { useCallback } from 'react';
import { useDispatch } from 'core/common/hooks';
import { UserSettings } from '../entities';
import { updateEmailConsentRequest, updateUserSettingsRequest } from '../store/actions';

export function useUserSettings() {
  const dispatch = useDispatch();

  const doUpdateEmailConsentRequest = useCallback(
    (value: boolean) => {
      dispatch(updateEmailConsentRequest(value));
    },
    [dispatch],
  );

  const doUpdateUserSettingsRequest = useCallback(
    (data: Partial<UserSettings>) => {
      dispatch(updateUserSettingsRequest(data));
    },
    [dispatch],
  );

  return {
    updateEmailConsentRequest: doUpdateEmailConsentRequest,
    updateUserSettingsRequest: doUpdateUserSettingsRequest,
  };
}
